import Container from "@material-ui/core/Container";
import React, {Component} from "react";
import MyButton from "../Buttons/MyButton";
import Toolbar from "../Menu/Toolbar";
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";
import {makeStyles} from '@material-ui/core/styles';
import {
    after_tool,
    font_style,
    small_style,
    small_style_tmp,
    trash_style,
    spacer,
} from "../styles";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import TextField from "@material-ui/core/TextField";
import Trash from "./Trash.js";
import RangeSlider from "./Slider.js"
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import parentData from "../Data/ParentData.json";
import {saveParentData} from "../../actions";
import {numbersCheck, validateForm} from "../Signup/CheckInput";
import {myFirebase} from "../../firebase/firebase";
import {connect} from "react-redux";
import DateAndTimePickers from "./datepicker";

async function test(){

}

class TempJob extends Component {
    constructor() {
        super();
        this.state = {
            value: "",
            allData: {},
            menuOpen: false,
            num_of_children: "",
            start_date: null,
            end_date: null,
            min_date: new Date(),
            // start_date_text: "",
            // end_date_text: "",
            salary: 37,
            userData: parentData,
            errors: {
                num_of_children: "",
            },
        };
        this.onChange = this.onChange.bind(this);
        this.add = this.add.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    onChangeStartDate = (sDate) => {
        this.setState({start_date: sDate}, () => {
            this.setState({min_date: this.state.start_date});
            if (this.state.end_date < this.state.start_date) {
                this.setState({end_date: null})
            }
        });
    };

    onChangeEndDate = (eDate) => {
        this.setState({end_date: eDate});
    };

    handleInputChange = (evt) => {
        var value = evt.target.value;
        var type = evt.target.name;
        let errors = this.state.errors;
        switch (type) {
            case "num_of_children":
                errors.num_of_children = !numbersCheck(value, 0, 20)
                    ? "מספר הילדים אינו תקין"
                    : "";
                break;
        }
        this.setState({errors, [type]: value}, () => {
            console.log(errors);
        });
    };

    checkAllData = () => {
        let errors = this.state.errors;
        errors.num_of_children = !numbersCheck(this.state.num_of_children, 0, 20)
            ? "מספר הילדים אינו תקין"
            : "";
        this.setState({errors}, () => {
            console.log(errors);
        });
        if (validateForm(this.state.errors)) {
            return true;
        } else {
            return false;
        }
    };



    handleSaveData = () => {
        const {dispatch} = this.props;
        if (!this.checkAllData()) {
            window.alert("ישנם שדות שאינם תקינים");
        } else {
            let temp_data = loadTempPositionData();
            console.log(temp_data)
            const baseDb = myFirebase.firestore();
            const user = myFirebase.auth().currentUser;
            let userRef = baseDb.collection("members").doc(user.uid);
            const update = async () =>{
                await userRef.update(temp_data)
                this.props.history.push("/")
            };
            update()

        }
    };

    deleteTempData = () => {
        let deletedData = {
            temp_position: {},
        };
        const baseDb = myFirebase.firestore();
        const user = myFirebase.auth().currentUser;
        let userRef = baseDb.collection("members").doc(user.uid);
        const update = async () =>{
            await userRef.update(deletedData)
            this.props.history.push("/")
        };
        update()
    };

    add() {
        this.props.onButtonClick(this.state.value);
        this.setState({value: ""});
    }

    onChange(e) {
        this.setState({value: e.target.value});
    }

    async componentWillMount() {
        if(this.props.currUser === null) {
            this.props.history.push('/')
        }
        if (this.props.currUser !== undefined) {
            if (this.props.currUser.temp_position !== undefined && Object.keys(this.props.currUser.temp_position).length !== 0) {
                if (this.props.currUser.temp_position.start_date !== "" &&
                    this.props.currUser.temp_position.end_date !== ""
                ) {
                    this.setState({
                        start_date: new Date(this.props.currUser.temp_position.start_date)
                    });

                    this.setState({
                        end_date: new Date(this.props.currUser.temp_position.end_date)
                    });


                    this.setState({num_of_children: this.props.currUser.temp_position.num_of_children});
                    this.setState({salary: this.props.currUser.temp_position.salary});

                }

            }

        }
    }

    menuClickHandler = () => {
        this.setState((prevState) => {
            return {menuOpen: !prevState.menuOpen};
        });
    };

    backDropClickHandler = () => {
        this.setState({menuOpen: false});
    };

    render() {

        let sideDrawer;
        let backDrop;
        if (this.state.menuOpen) {
            sideDrawer = <SideDrawer closeMenu={this.backDropClickHandler}/>;
            backDrop = <BackDrop click={this.backDropClickHandler}/>;
        }

        const {errors} = this.state;
        const errStyle = {
            color: "red",
            fontSize: "12px",
            textAlign: "right",
            fontWeight: "bold",
        };


        return (
            <Container component="main" maxWidth="xs">
                <Toolbar
                    drawerClickHandler={this.menuClickHandler}
                    textPage="פרסום משרת בייביסיטר מיוחד חד פעמית"
                />
                {sideDrawer}
                {backDrop}
                <div style={font_style}>
                    <p style={after_tool}>בחר מועד:</p>


                    <p><DatePicker
                        name="start_date"
                        placeholderText="בחר תאריך התחלה"
                        selected={this.state.start_date}
                        defaultValue={this.state.start_date}
                        onChange={this.onChangeStartDate}
                        //minDate={new Date()}
                        minDate={this.state.min_date}
                        todayButton="היום"
                        timeInputLabel="   שעה:"
                        dateFormat="yyyy/MM/dd HH:mm:ss"
                        showTimeInput
                        shouldCloseOnSelect={false}
                        withPortal/></p>

                    <p>
                        <DatePicker
                            name="end_date"
                            selected={this.state.end_date}
                            onChange={this.onChangeEndDate}
                            minDate={this.state.start_date}
                            placeholderText="בחר תאריך סיום"
                            todayButton="היום"
                            timeInputLabel="   שעה:"
                            dateFormat="yyyy/MM/dd HH:mm:ss"
                            showTimeInput
                            variant="outlined"
                            shouldCloseOnSelect={false}
                            withPortal
                        />
                    </p>

                    <p>מספר ילדים בבית במועד הבייביסיטר</p>
                    <p>
                        <TextField
                            fullWidth
                            name="num_of_children"
                            defaultValue={this.state.num_of_children}
                            type="text"
                            size="200"
                            onChange={this.handleInputChange}
                            variant="outlined"
                        />
                    </p>
                    <p>
                        {errors.num_of_children.length > 0 && (
                            <span style={errStyle} className="error">
                {errors.num_of_children}
              </span>
                        )}
                    </p>

                    <p>תעריף לשעה (ש"ח)</p>
                    {ShowSlider(this.state.salary)}
                    {/* {RangeSlider()} */}
                    <div style={trash_style}>
                        <Trash onClick={this.deleteTempData}/>
                        אפס משרת בייביסיטר מיוחד חד פעמי
                    </div>
                    <p style={small_style_tmp}>
                        להמשך בירור פרטים והתקשרות יש ליצור קשר עם נותן השירות.
                    </p>
                    <MyButton text={"פרסום משרת בייביסיטר מיוחד חד פעמי"} onClick={this.handleSaveData}/>
                </div>
            </Container>
        );
    }
}


function ShowSlider(defaultSalary) {
    const marks = [
        {
            value: 25,
            label: "25",
        },
        {
            value: 50,
            label: "50",
        },
    ];

    function valuetext(value) {
        return `${value}shekel`;
    }

    return (
        <p>
            <Typography id="discrete_slider" gutterBottom></Typography>
            <p></p>
            <Slider
                id="salary"
                name="salary"
                defaultValue={defaultSalary}
                min={25}
                max={50}
                getAriaValueText={valuetext}
                aria-labelledby="discrete_slider"
                step={1}
                marks={marks}
                valueLabelDisplay="on"
            />
        </p>
    );
}

function loadTempPositionData() {

    let tempPositionData = {
        temp_position: {
            start_date: document.getElementsByName("start_date")[0].value,
            end_date: document.getElementsByName("end_date")[0].value,
            num_of_children: document.getElementsByName("num_of_children")[0].value,
            salary: document.getElementsByName("salary")[0].value,
        },
    };
    return tempPositionData;
}

function mapStateToProps(state) {
    return {
        currUser: state.currentUser,
    };
}

export default connect(mapStateToProps)(TempJob);
